export enum PageTemplates {
  AGENTS = 'agentsPage',
  AGENTS_INCENTIVES = 'agentIncentivesPage',
  HOMEPAGE = 'homePage',
  DESTINATION = 'destinationPage',
  DESTINATIONS_LIST = 'destinationListPage',
  HOTEL = 'hotel',
  INFORMATION = 'informationPage',
  LIST_PAGE = 'listPage',
  MODAL = 'modal',
  OFFERS = 'offersPage',
  PROMO = 'promoPage',
  RESORT = 'resortPage',
  TOUR_DETAILS_PAGE = 'tourDetailsPage',
  TRAVEL_GUIDE_PAGE = 'travelGuidePage',
  TRIP_TYPE_PAGE = 'tripTypePage',
  VIDEO_GUIDE_PAGE = 'videoGuidePage'
}

export enum PagePaths {
  AGENTS = 'agents',
  HOMEPAGE = 'homepage',
  INFO = 'info',
  OFFERS = 'offers',
  TERMS = 'terms-and-conditions'
}
